import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';
import { IUserPostRequest, IUsersGetResponse, IUsersParams } from '../model/usersModel';

export enum USERS_TYPES {
  SET_API_USERS_REQUEST_STATE = 'SET_API_USERS_REQUEST_STATE',
  SET_API_USERS_REQUEST_ERROR = 'SET_API_USERS_REQUEST_ERROR',
  SET_API_ALL_USERS_REQUEST_STATE = 'SET_API_ALL_USERS_REQUEST_STATE',
  SET_API_ALL_USERS_REQUEST_ERROR = 'SET_API_ALL_USERS_REQUEST_ERROR',
  GET_ALL = 'USERS_GET_ALL',
  GET_ALL_SUCCESS = 'USERS_GET_ALL_SUCCESS',
  GET_ONE = 'USERS_GET_ONE',
  GET_ONE_SUCCESS = 'USERS_GET_ONE_SUCCESS',
  ADD = 'USERS_ADD',
  DELETE = 'USERS_DELETE',
}

export interface GetAllUsersAction {
  type: USERS_TYPES.GET_ALL;
}

export interface GetAllUsersSuccessAction {
  type: USERS_TYPES.GET_ALL_SUCCESS;
  payload: {
    users: IUsersGetResponse[];
  };
}

export interface GetOneUsersAction {
  type: USERS_TYPES.GET_ONE;
}

export interface GetOneUsersSuccessAction {
  type: USERS_TYPES.GET_ONE_SUCCESS;
  payload: {
    users: IUsersGetResponse;
  };
}

export interface SetApiAllUsersRequestStateAction {
  type: USERS_TYPES.SET_API_ALL_USERS_REQUEST_STATE;
  payload: {
    apiAllUsersRequestState: API_REQUEST_STATE;
  };
}

export interface SetApiAllUsersRequestErrorAction {
  type: USERS_TYPES.SET_API_ALL_USERS_REQUEST_ERROR;
  payload: {
    apiAllUsersRequestError: string;
  };
}

export interface SetApiUsersRequestStateAction {
  type: USERS_TYPES.SET_API_USERS_REQUEST_STATE;
  payload: {
    apiUsersRequestState: API_REQUEST_STATE;
  };
}

export interface SetApiUsersRequestStateAction {
  type: USERS_TYPES.SET_API_USERS_REQUEST_STATE;
  payload: {
    apiUsersRequestState: API_REQUEST_STATE;
  };
}

export interface SetApiUsersRequestErrorAction {
  type: USERS_TYPES.SET_API_USERS_REQUEST_ERROR;
  payload: {
    apiUsersRequestError: string;
  };
}

export interface DeleteUsersAction {
  type: USERS_TYPES.DELETE;
  payload: {
    params: IUsersParams;
  };
}

export interface AddUsersAction {
  type: USERS_TYPES.ADD;
  payload: {
    users: IUserPostRequest;
  };
}

export interface UsersState {
  apiUsersRequestState: API_REQUEST_STATE;
  apiUsersRequestError: string | null;
  apiAllUsersRequestState: API_REQUEST_STATE;
  apiAllUsersRequestError: string | null;
  user: IUsersGetResponse;
  allUsers: IUsersGetResponse[];
}

export type UsersActions =
  | SetApiUsersRequestStateAction
  | SetApiUsersRequestErrorAction
  | SetApiAllUsersRequestStateAction
  | SetApiAllUsersRequestErrorAction
  | AddUsersAction
  | GetOneUsersAction
  | GetOneUsersSuccessAction
  | GetAllUsersAction
  | GetAllUsersSuccessAction;
